var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import ScoresAndIndexesCardAPI from './scores-and-indexes-card-api';
import React, { Component } from 'react';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { Avatar, Card } from '@philips-internal/oswald-ui-components/lib/components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import clinicalNotesImage from '../../assets/images/global/clinical-notes-40x40.svg';
import { ReactComponent as PendingIcon } from '../../assets/images/global/time.svg';
import { ReactComponent as ReleasedIcon } from '../../assets/images/global/check.svg';
import './scores-and-indexes-card.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { DateFormatterUtil } from '../../utils';
const legends = [
    {
        color: 'signal-green-60',
        icon: React.createElement(ReleasedIcon, null),
        label: MessageService.translate('text.finished'),
        value: MessageService.translate('text.finished')
    },
    {
        color: 'signal-orange-45',
        icon: React.createElement(PendingIcon, null),
        label: MessageService.translate('tws.label-pending'),
        value: MessageService.translate('tws.label-pending')
    }
];
let ScoresAndIndexesCard = class ScoresAndIndexesCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { dateEvaluation, idScoreIndexes, onClick, professional, status, } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        dateEvaluation,
                        idScoreIndexes,
                        professional,
                        status,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    getStatusIcon() {
        const { status } = this.props;
        if (status?.toUpperCase() === 'A') {
            return React.createElement(ReleasedIcon, { className: 'c-scores-and-indexes-card__color-green' });
        }
        return React.createElement(PendingIcon, { className: 'c-scores-and-indexes-card__color-orange' });
    }
    renderStatus() {
        return (React.createElement("div", { className: 'c-scores-and-indexes-card__status' }, this.getStatusIcon()));
    }
    renderIndicatorColorStatus() {
        const { status } = this.props;
        if (status?.toUpperCase() === 'A') {
            return React.createElement("div", { className: 'c-scores-and-indexes-card__indicator-color-green' });
        }
        return React.createElement("div", { className: 'c-scores-and-indexes-card__indicator-color-orange' });
    }
    renderIndicator() {
        return (React.createElement("div", { className: 'c-scores-and-indexes-card__indicator' }, this.renderIndicatorColorStatus()));
    }
    renderAvatar() {
        const { descScore, professional, dateEvaluation } = this.props;
        const renderData = DateFormatterUtil.short(dateEvaluation);
        return (React.createElement("div", { className: 'c-scores-and-indexes-card__cn-avatar' },
            this.renderStatus(),
            React.createElement(Avatar, { image: clinicalNotesImage, title: renderData, subtitle: professional, description: descScore }),
            this.renderQtPunctuation()));
    }
    renderQtPunctuation() {
        const { qtPunctuation } = this.props;
        return (React.createElement("div", { className: "c-scores-and-indexes-card__punctuation" },
            React.createElement("p", { className: 'c-scores-and-indexes-card__text' }, `${MessageService.translate('tws.qt-punctuation')}`),
            React.createElement("span", { className: 'c-scores-and-indexes-card__qt-punctuation' }, qtPunctuation)));
    }
    render() {
        const { idScoreIndexes } = this.props;
        return (React.createElement(Card, { className: 'c-scores-main', selectionType: SelectionType.SINGLE, superscription: legends, width: 12, onClick: this.handleClick, uuid: generateUUID(), key: idScoreIndexes },
            this.renderIndicator(),
            React.createElement("div", { className: 'c-scores-and-indexes-card__cn-wrapper', onClick: () => this.handleClick() }, this.renderAvatar())));
    }
};
ScoresAndIndexesCard = __decorate([
    AwesomeComponent({ api: ScoresAndIndexesCardAPI, type: ComponentType.DATA_DISPLAY })
], ScoresAndIndexesCard);
export default ScoresAndIndexesCard;
//# sourceMappingURL=scores-and-indexes-card.js.map